export function maskedEmail(email: string): string {
  const [localPart, domain] = email.split('@');
  if (!domain) {
    return email;
  }

  const maskedLocalPart =
    localPart.length > 3 ? localPart.substring(0, 3) + '*'.repeat(localPart.length - 3) : localPart;

  return `${maskedLocalPart}@${domain}`;
}
